export const whitepapers = [
    {
        id: 1,
        category: 'whitepaper',
        topic: 'Cryptography and Security',
        title: 'LazyLedger',
        subtitle: 'A Distributed Data Availability Ledger With Client-Side Smart Contracts',
        downloadUrl: 'https://arxiv.org/',
        url: 'https://arxiv.org/pdf/'
    },{
        id: 2,
        category: 'whitepaper',
        topic: 'Cryptography and Security',
        title: 'Fraud and Data Availability Proofs',
        subtitle: 'Maximising Light Client Security and Scaling Blockchains with Dishonest Majorities',
        downloadUrl: 'https://arxiv.org/',
        url: 'https://arxiv.org/pdf/'
    },{
        id: 3,
        category: 'whitepaper',
        topic: 'Cryptography and Security',
        title: 'Securely Scaling Blockchain Base Layers',
        subtitle: '',
        downloadUrl: 'https://discovery.ucl.ac.uk/id/',
        url: 'https://discovery.ucl.ac.uk/id/'
    },
]
